import { render, staticRenderFns } from "./TransferReviewer.vue?vue&type=template&id=a2f4dae0"
import script from "./TransferReviewer.vue?vue&type=script&lang=js"
export * from "./TransferReviewer.vue?vue&type=script&lang=js"
import style0 from "./TransferReviewer.vue?vue&type=style&index=0&id=a2f4dae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports